export default __webpack_public_path__ + "static/media/collected-coin.66525749.svg";